export const HOME_PAGE = "HomePage";
export const PENDING_APPOINTMENT_DETAILS_ID = "PendingAppointmentDetailsId";
export const PENDING_APPOINTMENTS = "PendingAppointments";
export const RESERVATION_ADMIN = "ReservationAdministration";
export const SINGLE_RESERVATION_ADMIN_ID = "SingleReservationAdministrationId";
export const APPOINTMENT_DETAILS_ID = "AppointmentDetailsId";
export const APPOINTMENTS = "Appointments";
export const USER_PAGE = "UserPage";
export const SETTINGS_VIEW = "SettingsView";
export const PROFILE_EDIT_VIEW = "ProfileEditView";
export const PRICE_LISTING_PAGE = "PriceListingPage";
export const SINGLE_PET_VIEW = "SinglePetView";
export const TERMS_AND_CONDITIONS = "TermsAndConditions";
export const ABOUT_US = "AboutUs";
export const USER_CHANGE_PASSWORD = "UserChangePassword";
export const TEMPLATE_PAGE = "Templates";
export const SINGLE_TEMPLATE_PAGE = "SingleTemplate";
export const SINGLE_TEMPLATE_VIEW = "SingleTemplateView";
export const ADMINISTRATION = "Administration";
export const WAREHOUSE="Warehouse"
export const BLOOD_DONORS = "BloodDonors";
export const SPECIES_ADMINISTRATION = "SpeciesAdministration";
export const MY_CLINIC = "MyClinic";
export const CLINIC_USERS = "UserAdministration";
export const INBOX = "Inbox";
export const FEEDBACK = "Feedback"
export const SPAS_HOME_PAGE = "SapsHomePage"
export const SPAS_BOXES_LIST = "SapsBoxesList"
export const SAPS_PETS_LIST = "SapsPetsList"
export const SAPS_SINGLE_BOX_VIEW = "SapsSingleBoxView"
export const SAPS_SINGLE_ARCHIVE_VIEW = "SapsSingleArchiveView"
export const SAPS_SINGLE_PET_VIEW = "SapsSinglePetView"
export const SINGLE_THERAPY_VIEW = "SingleTherapyView"
export const SAPS_AI = "SapsAiAssistant"
